"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCartLineKey = buildCartLineKey;
exports.buildMenuCategories = buildMenuCategories;
exports.buildOrderLineFromCartItem = buildOrderLineFromCartItem;
exports.calculateUnitPrice = calculateUnitPrice;
exports.countCategoryItems = countCategoryItems;
exports.flattenMenuItems = flattenMenuItems;
exports.getRemovedLabels = getRemovedLabels;
exports.getSelectedOptionLabels = getSelectedOptionLabels;
exports.itemNeedsCustomization = itemNeedsCustomization;
exports.parseMenuResponse = parseMenuResponse;
exports.validateOptionSelection = validateOptionSelection;
/** Normalise et calcule les prix du menu New Cactus (GET /menu). */

function parseMenuResponse(data) {
  return Array.isArray(data?.menu) ? data.menu : [];
}
function countCategoryItems(category) {
  let count = (category.items ?? []).length;
  for (const sub of category.subsections ?? []) {
    count += (sub.items ?? []).length;
  }
  return count;
}
function buildMenuCategories(menu) {
  return menu.map(cat => ({
    id: cat.id,
    name: cat.name,
    icon: cat.icon ?? null,
    count: countCategoryItems(cat)
  })).filter(cat => cat.count > 0);
}
function flattenMenuItems(menu) {
  const items = [];
  for (const cat of menu) {
    const pushItem = (item, subsectionName = null) => {
      if (!item?.id) return;
      items.push({
        ...item,
        categoryId: cat.id,
        categoryName: cat.name,
        subsectionName
      });
    };
    for (const item of cat.items ?? []) pushItem(item);
    for (const sub of cat.subsections ?? []) {
      for (const item of sub.items ?? []) pushItem(item, sub.name);
    }
  }
  return items;
}
function itemNeedsCustomization(item) {
  const hasOptions = (item.option_groups ?? []).length > 0;
  const hasRemovable = (item.removable ?? []).length > 0;
  return hasOptions || hasRemovable;
}
function calculateUnitPrice(item, selectedOptionIds = []) {
  const base = Number(item.price) || 0;
  const optionSet = new Set(selectedOptionIds.map(Number));
  let extras = 0;
  for (const group of item.option_groups ?? []) {
    for (const opt of group.options ?? []) {
      if (optionSet.has(Number(opt.id))) {
        extras += Number(opt.price) || 0;
      }
    }
  }
  return base + extras;
}
function getSelectedOptionLabels(item, selectedOptionIds = []) {
  const optionSet = new Set(selectedOptionIds.map(Number));
  const labels = [];
  for (const group of item.option_groups ?? []) {
    for (const opt of group.options ?? []) {
      if (optionSet.has(Number(opt.id))) labels.push(opt.label);
    }
  }
  return labels;
}
function getRemovedLabels(item, removedIds = []) {
  const idSet = new Set(removedIds.map(Number));
  return (item.removable ?? []).filter(ing => idSet.has(Number(ing.id))).map(ing => ing.name);
}
function validateOptionSelection(item, selectedOptionIds = []) {
  const selected = new Set(selectedOptionIds.map(Number));
  for (const group of item.option_groups ?? []) {
    if (!group.required) continue;
    const groupOptionIds = (group.options ?? []).map(o => Number(o.id));
    const hasChoice = groupOptionIds.some(id => selected.has(id));
    if (!hasChoice) {
      return `Choisissez une option pour « ${group.name} ».`;
    }
    if (group.selection === 'single') {
      const count = groupOptionIds.filter(id => selected.has(id)).length;
      if (count > 1) {
        return `Une seule option pour « ${group.name} ».`;
      }
    }
  }
  return null;
}
function buildCartLineKey(menuItemId, optionIds = [], removedIds = []) {
  const opts = [...optionIds].map(Number).sort((a, b) => a - b).join(',');
  const rem = [...removedIds].map(Number).sort((a, b) => a - b).join(',');
  return `${menuItemId}|${opts}|${rem}`;
}
function buildOrderLineFromCartItem(item) {
  return {
    menu_item_id: Number(item.menuItemId),
    quantity: item.quantity,
    option_ids: item.optionIds ?? [],
    removed_ingredient_ids: item.removedIngredientIds ?? [],
    ...(item.notes ? {
      notes: item.notes
    } : {})
  };
}